var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('p',{class:_vm.isClear ?
      'text__sr text-secondary' :
      'text__sb'},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"sp__1xs5x"}),_c('p',{class:_vm.isClear ?
      'text__sr text-secondary' :
      'text__sr'},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }